import { useEffect } from "react";
import {
  applyConsentToTracking,
  initGoogleConsentModeDefaults,
} from "../../utils/cookieConsent";

/**
 * Listens for CookieYes events and (re)applies consent.
 * Re-tries shortly after each event because window.getCkyConsent()
 * can briefly lag the DOM event after Accept.
 */
const ConsentManager = () => {
  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    initGoogleConsentModeDefaults();
    applyConsentToTracking();

    const handle = (e) => {
      applyConsentToTracking(e?.detail);
      window.setTimeout(() => applyConsentToTracking(), 150);
      window.setTimeout(() => applyConsentToTracking(), 600);
    };

    const events = [
      "cookieyes_consent_update",
      "cookieyes_banner_load",
      "cookieyes_banner_loaded",
      "CookieyesConsentUpdate",
    ];
    events.forEach((n) => document.addEventListener(n, handle));

    return () => {
      events.forEach((n) => document.removeEventListener(n, handle));
    };
  }, []);

  return null;
};

export default ConsentManager;
